import {
    COMMAND_CENTER_UPGRADE_REQUEST,
    COMMAND_CENTER_UPGRADE_ERROR,
    COMMAND_CENTER_UPGRADE_SUCCESS,
    COMMAND_CENTER_UPGRADE_OPEN_CONFIRMATION,
    COMMAND_CENTER_UPGRADE_CLOSE_CONFIRMATION,
    COMMAND_CENTER_UPGRADE_SHOW_HIGHLIGHT,
    COMMAND_CENTER_UPGRADE_HIDE_HIGHLIGHT,
} from 'state/actions/command_center_upgrade'

const initialState = {
    submitting: false,
    submitted: false,
    confirmationOpened: false,
    errorMessage: '',
    highlighted: false,
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case COMMAND_CENTER_UPGRADE_REQUEST: {
        return {
            ...state,
            submitted: false,
            submitting: true,
            errorMessage: '',
        }
    }
    case COMMAND_CENTER_UPGRADE_SUCCESS: {
        return {
            ...state,
            submitted: true,
            submitting: false,
        }
    }
    case COMMAND_CENTER_UPGRADE_ERROR: {
        return {
            ...state,
            submitted: false,
            submitting: false,
            errorMessage: action.payload.errorMessage,
            confirmationOpened: false,
        }
    }
    case COMMAND_CENTER_UPGRADE_OPEN_CONFIRMATION: {
        return {
            ...state,
            confirmationOpened: true,
        }
    }
    case COMMAND_CENTER_UPGRADE_CLOSE_CONFIRMATION: {
        return {
            ...state,
            submitted: false,
            confirmationOpened: false,
        }
    }
    case COMMAND_CENTER_UPGRADE_SHOW_HIGHLIGHT: {
        return {
            ...state,
            highlighted: true,
        }
    }
    case COMMAND_CENTER_UPGRADE_HIDE_HIGHLIGHT: {
        return {
            ...state,
            highlighted: false,
        }
    }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/command_center_upgrade.js